module.exports = __webpack_public_path__ + "static/media/PageTitle-home-bg.be70d7dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/head-and-foot/PageTitle-home-bg.jpg
// module id = 29
// module chunks = 0